<button
  aria-label="mehr Informationen. Das Popup öffnet sich unterhalb"
  type="button"
  (click)="onClick()"
  class="info-icon"
  #icon
>
  <span class="material-symbols-outlined" aria-hidden="true">info</span>
</button>
